// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".taxcode{-ms-flex:1;flex:1}.taxcode__error{margin-top:.5rem;margin-right:1rem;color:#ba1b1b;text-align:end;font-family:Montserrat,-apple-system,BlinkMacSystemFont,Roboto,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;font-size:.875rem;font-weight:500;line-height:1.25rem;letter-spacing:.015625rem}", "",{"version":3,"sources":["taxCode.scss"],"names":[],"mappings":"AAqGA,SACE,UAAO,CAAP,MACF,CACA,gBACE,gBAAkB,CAClB,iBAAkB,CAClB,aAAc,CACd,cAAe,CACf,8IAA4K,CAC5K,iBAAmB,CACnB,eAAgB,CAChB,mBAAoB,CACpB,yBACF","file":"taxCode.scss","sourcesContent":[":export {\n  main100: white;\n  main30: #20789A;\n  main20: #016489;\n  main10: #004C6A;\n  main0: black;\n  primary100: white;\n  primary99: #EFFFFF;\n  primary95: #B4FDFF;\n  primary90: #6EF6FC;\n  primary80: #4CD9DF;\n  primary70: #1EBEC1;\n  primary60: #00A1A6;\n  primary50: #008489;\n  primary40: #00696D;\n  primary30: #004F52;\n  primary20: #00373A;\n  primary10: #002022;\n  primary5: #191C1D;\n  primary0: black;\n  secondary100: white;\n  secondary99: #EFFFFF;\n  secondary95: #B4FDFF;\n  secondary90: #CCE8E8;\n  secondary80: #B1CCCD;\n  secondary70: #95B0B1;\n  secondary60: #7B9596;\n  secondary50: #627C7D;\n  secondary40: #4A6364;\n  secondary30: #334B4C;\n  secondary20: #1B3436;\n  secondary10: #051F20;\n  secondary0: black;\n  tertiary100: white;\n  tertiary99: #FDFCFF;\n  tertiary95: #EAF1FF;\n  tertiary90: #D3E3FF;\n  tertiary80: #B4C8E9;\n  tertiary70: #99ACCC;\n  tertiary60: #7F92B1;\n  tertiary50: #657896;\n  tertiary40: #4C5F7C;\n  tertiary30: #354864;\n  tertiary20: #1D314C;\n  tertiary10: #061C35;\n  tertiary0: black;\n  error100: white;\n  error99: #FCFCFC;\n  error96: #FEF6F6;\n  error95: #FFEDE9;\n  error90: #FFDAD4;\n  error80: #FFB4A9;\n  error70: #FF897A;\n  error60: #FF5449;\n  error50: #DD3730;\n  error45: #C81414;\n  error40: #BA1B1B;\n  error30: #930006;\n  error20: #680003;\n  error10: #410001;\n  error0: black;\n  neutral100: white;\n  neutral99: #FFFBF7;\n  neutral97: #EFF1F1;\n  neutral96: #F5F2EB;\n  neutral95: #F7F0E7;\n  neutral90: #E8E1D8;\n  neutral80: #CCC5BD;\n  neutral70: #B0AAA2;\n  neutral60: #969088;\n  neutral50: #7B766F;\n  neutral40: #625E57;\n  neutral30: #4A463F;\n  neutral20: #33302A;\n  neutral10: #1E1B16;\n  neutral0: black;\n  neutralVariant100: white;\n  neutralVariant99: #FFFBFC;\n  neutralVariant95: #F6EEF9;\n  neutralVariant93: #F4F4F4;\n  neutralVariant90: #E8E0EB;\n  neutralVariant85: #D8D8D8;\n  neutralVariant80: #CBC4CE;\n  neutralVariant70: #B0A9B4;\n  neutralVariant65: #8E9192;\n  neutralVariant60: #958F99;\n  neutralVariant50: #7B757F;\n  neutralVariant40: #615C66;\n  neutralVariant30: #4A454E;\n  neutralVariant20: #332F37;\n  neutralVariant10: #1E1A22;\n  neutralVariant0: black;\n  success40: #008262;\n  surface: #FAFDFC;\n  surface1: rgba(30, 190, 193, 0.05);\n  surface2: rgba(30, 190, 193, 0.08);\n  surface3: rgba(30, 190, 193, 0.11);\n  surface4: rgba(30, 190, 193, 0.12);\n  surface5: rgba(30, 190, 193, 0.14);\n}\n\n.taxcode {\n  flex: 1;\n}\n.taxcode__error {\n  margin-top: 0.5rem;\n  margin-right: 1rem;\n  color: #BA1B1B;\n  text-align: end;\n  font-family: \"Montserrat\", -apple-system, BlinkMacSystemFont, \"Roboto\", \"Segoe UI\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.25rem;\n  letter-spacing: 0.015625rem;\n}"]}]);
// Exports
exports.locals = {
	"main100": "#fff",
	"main30": "#20789a",
	"main20": "#016489",
	"main10": "#004c6a",
	"main0": "#000",
	"primary100": "#fff",
	"primary99": "#efffff",
	"primary95": "#b4fdff",
	"primary90": "#6ef6fc",
	"primary80": "#4cd9df",
	"primary70": "#1ebec1",
	"primary60": "#00a1a6",
	"primary50": "#008489",
	"primary40": "#00696d",
	"primary30": "#004f52",
	"primary20": "#00373a",
	"primary10": "#002022",
	"primary5": "#191c1d",
	"primary0": "#000",
	"secondary100": "#fff",
	"secondary99": "#efffff",
	"secondary95": "#b4fdff",
	"secondary90": "#cce8e8",
	"secondary80": "#b1cccd",
	"secondary70": "#95b0b1",
	"secondary60": "#7b9596",
	"secondary50": "#627c7d",
	"secondary40": "#4a6364",
	"secondary30": "#334b4c",
	"secondary20": "#1b3436",
	"secondary10": "#051f20",
	"secondary0": "#000",
	"tertiary100": "#fff",
	"tertiary99": "#fdfcff",
	"tertiary95": "#eaf1ff",
	"tertiary90": "#d3e3ff",
	"tertiary80": "#b4c8e9",
	"tertiary70": "#99accc",
	"tertiary60": "#7f92b1",
	"tertiary50": "#657896",
	"tertiary40": "#4c5f7c",
	"tertiary30": "#354864",
	"tertiary20": "#1d314c",
	"tertiary10": "#061c35",
	"tertiary0": "#000",
	"error100": "#fff",
	"error99": "#fcfcfc",
	"error96": "#fef6f6",
	"error95": "#ffede9",
	"error90": "#ffdad4",
	"error80": "#ffb4a9",
	"error70": "#ff897a",
	"error60": "#ff5449",
	"error50": "#dd3730",
	"error45": "#c81414",
	"error40": "#ba1b1b",
	"error30": "#930006",
	"error20": "#680003",
	"error10": "#410001",
	"error0": "#000",
	"neutral100": "#fff",
	"neutral99": "#fffbf7",
	"neutral97": "#eff1f1",
	"neutral96": "#f5f2eb",
	"neutral95": "#f7f0e7",
	"neutral90": "#e8e1d8",
	"neutral80": "#ccc5bd",
	"neutral70": "#b0aaa2",
	"neutral60": "#969088",
	"neutral50": "#7b766f",
	"neutral40": "#625e57",
	"neutral30": "#4a463f",
	"neutral20": "#33302a",
	"neutral10": "#1e1b16",
	"neutral0": "#000",
	"neutralVariant100": "#fff",
	"neutralVariant99": "#fffbfc",
	"neutralVariant95": "#f6eef9",
	"neutralVariant93": "#f4f4f4",
	"neutralVariant90": "#e8e0eb",
	"neutralVariant85": "#d8d8d8",
	"neutralVariant80": "#cbc4ce",
	"neutralVariant70": "#b0a9b4",
	"neutralVariant65": "#8e9192",
	"neutralVariant60": "#958f99",
	"neutralVariant50": "#7b757f",
	"neutralVariant40": "#615c66",
	"neutralVariant30": "#4a454e",
	"neutralVariant20": "#332f37",
	"neutralVariant10": "#1e1a22",
	"neutralVariant0": "#000",
	"success40": "#008262",
	"surface": "#fafdfc",
	"surface1": "rgba(30,190,193,.05)",
	"surface2": "rgba(30,190,193,.08)",
	"surface3": "rgba(30,190,193,.11)",
	"surface4": "rgba(30,190,193,.12)",
	"surface5": "rgba(30,190,193,.14)"
};
module.exports = exports;
